import { useEffect } from 'react';

import { useAppDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import { MetaData } from 'Components/MetaData';
import { ProductCollection } from '../Components/ProductCollection';

import { accessoriesCollection } from 'assets/content/productPages/accessoriesCollection';

import * as productsActions from 'dux/products/actions';
import * as productsSelectors from 'dux/products/selectors';

export const AccessoriesProductCollection = () => {
  const productsBlockContent = useSelector(productsSelectors.getAccessoriesProductsBlockContent);
  const dispatch = useAppDispatch();

  // Since we are displaying digital gift on this page, we need this API call.
  useEffect(() => {
    dispatch(productsActions.fetchGiftsSets());
  }, []);

  return (
    <>
      <MetaData
        description="From award-winning, custom hair brushes to clean, fine-fragrance candles, all our accessories are made with a mind for sustainability and an eye for luxury. Shop Prose Accessories."
        title="Self-Care Beauty Accessories – Prose | Accessories"
      />
      <ProductCollection
        content={accessoriesCollection}
        dataFrom="product-grid"
        productsBlockContent={productsBlockContent}
        productsToDisplayOnARow={[2, 3, 4]}
      />
    </>
  );
};
